const darkIndigo = {
  10: '#222244',
  50: '#2D2E5C',
  100: '#3B3C86',
  200: '#5657C3',
}

export default darkIndigo
